import React from 'react';
import Media from 'react-media';
import Icon from '../app/common/components/Icon';
import { LoadingPage } from '../app/common/components/LoadingPage';
import ICONS from '../app/common/constants/icons';
import { MQS } from '../app/common/constants/styles';
import Logo from '../app/common/logos/RakutenLogo';
import { IClientConfig, IPresentationConfig } from '../config/clientConfig';
import FooterContainer from '../footer/FooterContainer';
import Header from '../header/Header';
import { TranslationHelpers } from '../i18n/translationHelpers';
import { IRoute } from '../routes/routes';
import SignOutLinkContainer from '../signOut/SignOutLinkContainer';
import TilesDesktop from './TilesDesktop';
import {
    AvailablePoints,
    Base,
    BaseTile,
    baseTileMobile,
    BaseWrapper,
    DefaultHeader,
    ExternalLink,
    Greeting,
    IconWrapper,
    LogOutIcon,
    LogOutWrapper,
    LogoWrapper,
    MobileMain,
    MyDataLink,
    noPointsMyDataWrapperStyleMobile,
    NoPointsTileWrapper,
    PendingPoints,
    PointsLine,
    PointsLink,
    PointsTile,
    pointsTileStyle,
    TileLink,
    TilePointsText,
    TilePointsTitle,
    TileText,
    TileTitle,
    TipOfTitle,
    Title,
    TopWrapper,
    UserName,
    ToMembershipWrapper,
    ExternalBlueLink,
    BackLinkWrapper,
    HorizontalWrapper,
    BuTile,
    SignOutButton,
} from './tilesStyle';
import { NameIcon } from '../details/sideBar/SideBar';
import * as webStorage from '@com.rakuten.esd/myr-web-storage';
import { RegionHelper } from '../utils/RegionHelper';
import { content } from './BuContent';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import BuVerticalTiles from './BuVerticalTiles';
import { addRatEvent } from '../utils/ratClickEvents';
import { TopPageNotificationBanner } from './TopPageNotificationBanner';

export interface ITilesProps {
    user: any;
    clientConfig: IClientConfig;
    presentationConfig: IPresentationConfig;
    loading: boolean;
    routes: IRoute[];
    currentLanguage: string;
    targetUrl: string;
    showExternalBankLink: string;
    isShowSignOut: boolean;
    returnUrl: string;
    returnUrlText: string;
    hasEKYC: boolean;
    hasSocialLink: boolean;
}
export interface ITileState {}
class Tiles extends React.Component<ITilesProps & InjectedIntlProps, ITileState> {
    constructor(props: ITilesProps & InjectedIntlProps) {
        super(props);
        this.getUserName = this.getUserName.bind(this);
    }

    public render() {
        const {
            user,
            clientConfig,
            presentationConfig,
            loading,
            routes,
            currentLanguage,
            targetUrl,
            presentationConfig: {
                showSections: { points: showPoints, subtitle, mydata },
            },
            hasEKYC,
            hasSocialLink,
            showExternalBankLink,
            isShowSignOut,
            returnUrl,
            returnUrlText,
            intl,
        } = this.props;

        if (loading) {
            return <LoadingPage />;
        }
        const routesMap = routes.filter(
            (route) =>
                route.id !== 'points' &&
                route.id !== 'cancel.membership' &&
                (route.id !== 'ekyc' || hasEKYC) &&
                (route.id !== 'linked.accounts' || hasSocialLink),
        );
        const newTabAriaLabel = intl.formatMessage(
            TranslationHelpers.getMessageDescriptor('newTab.ariaLabel'),
        );

        return (
            <Base>
                {!clientConfig ? (
                    <DefaultHeader>
                        <LogoWrapper>
                            <Logo />
                        </LogoWrapper>
                    </DefaultHeader>
                ) : (
                    <Header clientConfig={clientConfig} />
                )}
                <BaseWrapper>
                    <TopWrapper>
                        <Title>
                            {TranslationHelpers.getFormattedMessage('menu.page.top.title')}
                        </Title>
                        {subtitle && (
                            <TipOfTitle>
                                {TranslationHelpers.getFormattedMessage(
                                    'menu.page.top.tip.of.title',
                                )}
                            </TipOfTitle>
                        )}
                        <Greeting>
                            {TranslationHelpers.getFormattedMessage('app.greeting', {
                                memberName: (
                                    <UserName className="notranslate">
                                        {this.getUserName()}
                                    </UserName>
                                ),
                            })}
                        </Greeting>
                    </TopWrapper>

                    <Media
                        query={`(max-width: ${MQS.mq2Max})`}
                        render={() => (
                            <MobileMain>
                                {!RegionHelper.isEU() && <TopPageNotificationBanner />}
                                {showPoints ? (
                                    <PointsTile localStyles={pointsTileStyle}>
                                        <PointsLink to="/points-club">
                                            <IconWrapper>
                                                <Icon
                                                    icon={ICONS.POINTS_CLUB}
                                                    fill="#ffffff"
                                                    size={'40'}
                                                    viewBoxMax={'29'}
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                />
                                                <Icon
                                                    icon={ICONS.ARROW_RIGHT}
                                                    fill="#ffffff"
                                                    size={'16'}
                                                />
                                            </IconWrapper>
                                            <TilePointsTitle>
                                                {TranslationHelpers.getFormattedMessage(
                                                    'profile.points_club',
                                                )}
                                            </TilePointsTitle>
                                            <TilePointsText>
                                                {TranslationHelpers.getFormattedMessage(
                                                    'profile.points_check',
                                                )}
                                            </TilePointsText>
                                            <PointsLine></PointsLine>
                                            <AvailablePoints>
                                                {TranslationHelpers.getFormattedMessage(
                                                    'points.available.balance',
                                                )}
                                                <span>
                                                    {user.superPointsBalance
                                                        ? user.superPointsBalance
                                                        : 0}
                                                </span>
                                            </AvailablePoints>
                                            <PendingPoints>
                                                {TranslationHelpers.getFormattedMessage(
                                                    'points.pending.balance',
                                                )}
                                            </PendingPoints>
                                        </PointsLink>
                                    </PointsTile>
                                ) : null}
                                {routesMap.map((route, index) => (
                                    <BaseTile localStyles={baseTileMobile} key={route.path}>
                                        <TileLink className={`tst-tl${index}`} to={route.path}>
                                            <IconWrapper>
                                                <Icon
                                                    icon={route.icon}
                                                    fill="#7F7F7F"
                                                    size={'40'}
                                                    viewBoxMax={'29'}
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                />
                                                <Icon
                                                    icon={ICONS.ARROW_RIGHT}
                                                    fill="#9c9c9c"
                                                    size={'16'}
                                                />
                                            </IconWrapper>
                                            <TileTitle>
                                                {TranslationHelpers.getFormattedMessage(
                                                    route.name.id,
                                                )}
                                            </TileTitle>
                                            <TileText>
                                                {TranslationHelpers.getFormattedMessage(
                                                    route.text.id,
                                                )}
                                            </TileText>
                                        </TileLink>
                                    </BaseTile>
                                ))}
                                {mydata && (
                                    <NoPointsTileWrapper
                                        localStyles={noPointsMyDataWrapperStyleMobile}
                                    >
                                        <MyDataLink
                                            className={`tst-tl5`}
                                            onClick={() => {
                                                addRatEvent('mydata', 'mydata_link');
                                            }}
                                            href={targetUrl}
                                            target={'_blank'}
                                        >
                                            <IconWrapper>
                                                <Icon
                                                    icon={ICONS.MY_DATA}
                                                    fill="#7F7F7F"
                                                    size={'40'}
                                                    viewBoxMax={'29'}
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                />
                                                <Icon
                                                    icon={ICONS.NEW_WINDOW}
                                                    fill="#9c9c9c"
                                                    size={'16'}
                                                    viewBoxMax={'22'}
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    ariaLabel={newTabAriaLabel}
                                                    tabIndex={0}
                                                />
                                            </IconWrapper>
                                            <TileTitle>
                                                {TranslationHelpers.getFormattedMessage(
                                                    'top.page.mydata.title',
                                                )}
                                            </TileTitle>
                                            <TileText>
                                                {TranslationHelpers.getFormattedMessage(
                                                    'top.page.tip.of.mydata.title',
                                                )}
                                            </TileText>
                                        </MyDataLink>
                                    </NoPointsTileWrapper>
                                )}
                                {RegionHelper.isEU() && (
                                    <BuTile>
                                        <BuVerticalTiles buContent={content} />
                                    </BuTile>
                                )}
                            </MobileMain>
                        )}
                    />
                </BaseWrapper>
                <Media
                    query={`(min-width: ${MQS.mq3Min})`}
                    render={() => (
                        <TilesDesktop
                            user={user}
                            routes={routes}
                            clientConfig={clientConfig}
                            presentationConfig={presentationConfig}
                            currentLanguage={currentLanguage}
                            targetUrl={targetUrl}
                            loading={loading}
                            hasEKYC={hasEKYC}
                            hasSocialLink={hasSocialLink}
                            buContent={content}
                        />
                    )}
                />
                {showExternalBankLink && (
                    <BaseWrapper>
                        <ToMembershipWrapper>
                            <span>
                                {TranslationHelpers.getFormattedMessage(
                                    'top.page.to.external.bank.text',
                                )}
                            </span>
                            <ExternalBlueLink href={showExternalBankLink} target={'_blank'}>
                                {TranslationHelpers.getFormattedMessage(
                                    'top.page.to.external.bank.link.text',
                                )}
                            </ExternalBlueLink>
                            <Icon
                                icon={ICONS.NEW_WINDOW}
                                fill="#9c9c9c"
                                size={'16'}
                                viewBoxMax={'22'}
                                fillRule="evenodd"
                                clipRule="evenodd"
                                ariaLabel={newTabAriaLabel}
                                tabIndex={0}
                            />
                        </ToMembershipWrapper>
                    </BaseWrapper>
                )}
                {
                    <HorizontalWrapper>
                        <BackLinkWrapper>
                            <ExternalLink
                                href={returnUrl}
                                onClick={() => {
                                    webStorage.removeState();
                                }}
                            >
                                <NameIcon>
                                    <Icon
                                        className={'sidebar__name-icon__left'}
                                        icon={ICONS.BACK}
                                        size={'24'}
                                        viewBoxMax={'24'}
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                    />
                                    {TranslationHelpers.getFormattedMessage('button.back_to_site', {
                                        site: returnUrlText,
                                    })}
                                </NameIcon>
                            </ExternalLink>
                        </BackLinkWrapper>
                        {isShowSignOut && (
                            <LogOutWrapper>
                                <SignOutLinkContainer qaId="side-menu">
                                    <SignOutButton tabIndex={0}>
                                        <LogOutIcon>
                                            <Icon
                                                icon={ICONS.SIGN_OUT}
                                                size={'26'}
                                                viewBoxMax={'26'}
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                            />
                                            {TranslationHelpers.getFormattedMessage('app.logout')}
                                        </LogOutIcon>
                                    </SignOutButton>
                                </SignOutLinkContainer>
                            </LogOutWrapper>
                        )}
                    </HorizontalWrapper>
                }
                <FooterContainer />
            </Base>
        );
    }

    private getUserName() {
        const { currentLanguage, user } = this.props;
        if (
            currentLanguage === 'ja' ||
            currentLanguage === 'zh-TW' ||
            currentLanguage === 'zh-CN'
        ) {
            return (user.lastName || '') + ' ' + (user.firstName || '');
        } else {
            return (user.firstName || '') + ' ' + (user.lastName || '');
        }
    }
}

export default injectIntl(Tiles);
